export default "__VITE_ASSET__CXxDuroD__"